import { api } from './client'
import type { LoginRequest, SignupRequest, AuthResponse, User } from '../types/api'

export const authApi = {
  // 로그인
  login: (credentials: LoginRequest): Promise<AuthResponse> =>
    api.post('/auth/login', credentials),

  // 회원가입
  signup: (userData: SignupRequest): Promise<AuthResponse> =>
    api.post('/auth/signup', userData),

  // 토큰 갱신
  refresh: (): Promise<{ token: string }> =>
    api.post('/auth/refresh'),

  // 로그아웃
  logout: (): Promise<void> =>
    api.post('/auth/logout'),

  // 현재 사용자 정보 조회
  me: (): Promise<User> =>
    api.get('/auth/me'),

  // 비밀번호 재설정 요청
  forgotPassword: (email: string): Promise<{ message: string }> =>
    api.post('/auth/forgot-password', { email }),

  // 비밀번호 재설정
  resetPassword: (token: string, password: string): Promise<{ message: string }> =>
    api.post('/auth/reset-password', { token, password }),

  // 이메일 인증
  verifyEmail: (token: string): Promise<{ message: string }> =>
    api.post('/auth/verify-email', { token }),

  // 이메일 인증 재전송
  resendVerification: (): Promise<{ message: string }> =>
    api.post('/auth/resend-verification'),
}